import React, { useEffect, useState } from "react";
import "./styles.scss";
import { message, Popconfirm } from "antd";
import { deleteImage } from "./service/upload.service";
import { GetIconByName } from "../../config/icon";

// import "./mobile.scss";

const Index = ({ data, onClickRemove }) => {
  const [imageURL, setImageURL] = useState("");
  let inputElement = null;

  useEffect(() => {
    setImageURL("");
  }, []);

  //remove Image
  // const onClickRemove = async (key) => {
  //   // try {
  //   //   const RemoveImage = await deleteImage({ file_name: file_name });
  //   //   console.log("remove image", RemoveImage);
  //   //   if (RemoveImage.data.status) {
  //   //     console.log("Image Deleted");
  //   //     setImageURL("");
  //   //     message.success("Image Deleted");
  //   //   } else {
  //   //     console.log("Deleted Fail");
  //   //   }
  //   // } catch (error) {
  //   //   console.log("Error in deleting image", error);
  //   //   message.error("Error in deleting image");
  //   // }
  //   setImageURL("");
  // };

  const onClickCancel = (e) => {
    console.log(e);
    // message.error("");
  };

  inputElement = (
    <>
      <div
        className={`img-component-wrapper ${data.size} ${
          !data.imgUrl ? "default" : ""
        }`}
      >
        {!data.nonRemove && (
          <Popconfirm
            placement="topLeft"
            title="Delete the image"
            description="Are you sure to delete this Image?"
            onConfirm={onClickRemove}
            onCancel={onClickCancel}
            okText="Yes"
            cancelText="No"
          >
            <span className="remove-button"> {GetIconByName("cross")}</span>{" "}
          </Popconfirm>
        )}
        {data?.isPdf ? (
          <iframe
            src={data.imgUrl}
            title="PDF Preview"
            className={`img-component`}
          />
        ) : (
          <img className={`img-component`} src={data.imgUrl} alt="" />
        )}
      </div>
    </>
  );
  return <>{inputElement}</>;
};

export default Index;
